import React, { ReactNode } from 'react';
import MatchOfTheDayContentTabs from '../components/match-of-the-day/match-of-the-day-content-tabs';

export function MatchOfTheDayPage(): ReactNode {

    return (
        <MatchOfTheDayContentTabs />
    );
}
